import {
  FETCH_EMP_ALLOCATION_REQUEST,
  FETCH_EMP_ALLOCATION_SUCCESS,
  FETCH_EMP_ALLOCATION_FAILURE,
} from "../constants/EmpAllocationConstants";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const EmpAllocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMP_ALLOCATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_EMP_ALLOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case FETCH_EMP_ALLOCATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default EmpAllocationReducer;
